// 分享功能配置
export const shareConfig = {
  // 是否启用分享功能
  enabled: true,
  
  // 允许分享的页面路径列表
  shareablePages: [
    '/h5/newsDetail',
    '/newsDetail'
  ],
  
  // 默认分享内容
  defaultShareData: {
    title: '',
    desc: '点击查看更多精彩内容',
    link: '',
    imgUrl: ''
  }
}

// 检查分享功能是否启用
export const isShareEnabled = () => {
  return shareConfig.enabled
}

// 检查当前页面是否允许分享
export const isPageShareable = (routePath) => {
  if (!routePath) return false
  
  // 支持精确匹配和路径匹配
  return shareConfig.shareablePages.some(pagePath => {
    // 精确匹配
    if (routePath === pagePath) return true
    // 路径匹配（如 /h5/newsDetail?id=123）
    if (routePath.startsWith(pagePath)) return true
    return false
  })
}
